<app-base-modal
  [title]="productPackagesTitleModal[productPackagesDialogData.modalKey]"
  [showStateToggle]="isValid()"
>
  <div class="wrapper">
    @if (isLoading) {
      <app-loader/>
    }
    <mat-accordion [multi]="true">
      @for (productPackage of productPackagesData(); track $index) {
        <mat-expansion-panel [expanded]="productPackage.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <app-product-packages-accordion-title
                class="product-packages-accordion-title"
                [productPackage]="productPackage"
                [isEditModeActive]="isEditModeActive"
                (deleteRecord)="handleDelete($event, $index)"
              />
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-product-packages-form
            [parentId]="productPackagesDialogData.parentId"
            [productPackageFormGroup]="productPackageFormGroups()[$index]"
            [productPackageData]="productPackage"
            [isEditModeActive]="isEditModeActive"
            [noFirstData]="noFirstData()"
            [modalKey]="productPackagesDialogData.modalKey"
            (updateProductPackageData)="updateProductPackageData($event, $index)"
            (deleteProductPackage)="deleteProductPackage($index)"
          />
          @if (productPackage.id) {
            <div
              app-product-packages-files
              [productPackageId]="productPackage.id"
              [isEditModeActive]="isEditModeActive"
              class="product-packages-files"
            ></div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid()"
      (click)="handleAddNew()"
    >
      Добавить новую
    </button>
  </div>
</app-base-modal>
